import apiClient from "./api";

export async function fetchUserInfo() {
  try {
    const response = await apiClient.get("/user"); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return {
        success: false,
        message: "No response received",
        details: error.request,
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        success: false,
        message: "Request setup error",
        details: error.message,
      };
    }
  }
}

export async function getInstalled(data) {
  try {
    const response = await apiClient.get("/eomws/getinstall", {params: data}); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return {
        success: false,
        message: "No response received",
        details: error.request,
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        success: false,
        message: "Request setup error",
        details: error.message,
      };
    }
  }
}

export async function getNotUsed(data) {
  try {
    const response = await apiClient.get("/eomws/getnotusedimplants", {params: data}); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return {
        success: false,
        message: "No response received",
        details: error.request,
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        success: false,
        message: "Request setup error",
        details: error.message,
      };
    }
  }
}

export async function downloadExportInstall(data) {
  try {

    const response = await apiClient.get('/eomws/exportinstall', {
      responseType: 'blob', // Ensures the response is treated as a binary file
      params: data
    });

    // Create a URL for the blob
    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
    const url = window.URL.createObjectURL(blob);

    // Create a temporary anchor element to trigger the download
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', "Δηλωμένα μοσχεύματα.xlsx");

    // Append the link to the document, click it, and remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Revoke the URL to release memory
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading the file:', error);
  }
}

export async function downloadExportNotUsed(data) {
  try {

    const response = await apiClient.get('/eomws/exportnotusedimplants', {
      responseType: 'blob', // Ensures the response is treated as a binary file
      params: data

    });

    // Create a URL for the blob
    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
    const url = window.URL.createObjectURL(blob);

    // Create a temporary anchor element to trigger the download
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', "Μοσχεύματα προς εφαρμογή.xlsx");

    // Append the link to the document, click it, and remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Revoke the URL to release memory
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading the file:', error);
  }
}

export async function downloadExportUsed(data) {
  try {

    const response = await apiClient.get('/eomws/exportusedimplants', {
      responseType: 'blob', // Ensures the response is treated as a binary file
      params: data

    });

    // Create a URL for the blob
    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
    const url = window.URL.createObjectURL(blob);

    // Create a temporary anchor element to trigger the download
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', "Διανεμηθέντα μοσχεύματα.xlsx");

    // Append the link to the document, click it, and remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Revoke the URL to release memory
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading the file:', error);
  }
}

export async function downloadExportExpired(data) {
  try {

    const response = await apiClient.get('/eomws/exportexpiredimplants', {
      responseType: 'blob', // Ensures the response is treated as a binary file
      params: data

    });

    // Create a URL for the blob
    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
    const url = window.URL.createObjectURL(blob);

    // Create a temporary anchor element to trigger the download
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', "Ληγμένα μοσχεύματα.xlsx");

    // Append the link to the document, click it, and remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Revoke the URL to release memory
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading the file:', error);
  }
}

export async function downloadFile(id, filename, mimeType) {
  try {
    const response = await apiClient.post(
      `/eomws/download-file/${id}`,
      {}, // Add an empty payload if necessary
      { responseType: 'blob' } // Correctly set responseType for Axios
    );

    // Ensure the response contains data
    if (!response.data || !(response.data instanceof Blob)) {
      throw new Error('The response does not contain valid file data.');
    }

    // Create a Blob URL for the file
    const blob = new Blob([response.data], { type: mimeType });
    const url = window.URL.createObjectURL(blob);

    // Trigger the file download
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Revoke the object URL to release memory
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading the file:', error);
    alert('Failed to download the file. Please try again.');
  }
}


export async function getExpired(data) {
  try {
    const response = await apiClient.get("/eomws/getexpiredimplants", {params: data}); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return {
        success: false,
        message: "No response received",
        details: error.request,
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        success: false,
        message: "Request setup error",
        details: error.message,
      };
    }
  }
}

export async function getUsed(data) {
  try {
    const response = await apiClient.get("/eomws/getusedimplants", {params: data}); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return {
        success: false,
        message: "No response received",
        details: error.request,
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        success: false,
        message: "Request setup error",
        details: error.message,
      };
    }
  }
}


export async function getInstitutions() {
  try {
    const response = await apiClient.get("/eomws/getinstitutions"); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return {
        success: false,
        message: "No response received",
        details: error.request,
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        success: false,
        message: "Request setup error",
        details: error.message,
      };
    }
  }
}

export async function postInstitute(data) {
    try {
      const response = await apiClient.post("/eomws/postinstitude", data); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: "No response received",
          details: error.request,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: "Request setup error",
          details: error.message,
        };
      }
    }
  }

  export async function deleteInstitutionById(id) {
    try {
      const response = await apiClient.post("/eomws/actinstitude", {id: id, isactive: 0}); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: "No response received",
          details: error.request,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: "Request setup error",
          details: error.message,
        };
      }
    }
  }

  export async function deleteRelationsForInstitute(id) {
    try {
      const response = await apiClient.post("/eomws/deleterelationsforinstitude", {id: id}); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: "No response received",
          details: error.request,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: "Request setup error",
          details: error.message,
        };
      }
    }
  }
